import { cloneElement, isValidElement } from "react";
import { DropdownMenuGroup, DropdownMenuItem } from "components/common/dropdown/DropDownV2";
import { getWorkspaceSettingsSectionHref } from "pages/settings/workspace/workspaceSettingsVisibility";
import { cn } from "utils/cn";
import { DropdownSectionLabel } from "../DropdownSectionLabel";
import { WorkspaceSettingsQuickLinksProps } from "./WorkspaceSettingsQuickLinks.types";

const isSettingsSectionActive = (pathname: string, href: string, sectionId: string): boolean => {
  if (sectionId === "general") {
    return (
      pathname === href || pathname.endsWith("/settings") || pathname.includes("/settings/general")
    );
  }
  return pathname === href || pathname.startsWith(`${href}/`);
};

const shouldShowCategoryLabel = (
  sectionCount: number,
  sectionTitle: string | undefined,
  categoryLabel: string
): boolean => sectionCount > 1 || sectionTitle?.toLowerCase() !== categoryLabel.toLowerCase();

export const WorkspaceSettingsQuickLinks = ({
  categories,
  activePathname,
  workspaceId,
  onNavigate,
  onClose,
}: WorkspaceSettingsQuickLinksProps) => {
  if (categories.length === 0) {
    return null;
  }

  return (
    <>
      {categories.map((category) => {
        const showCategoryLabel = shouldShowCategoryLabel(
          category.sections.length,
          category.sections[0]?.title,
          category.label
        );

        return (
          <div key={category.id} className="flex flex-col">
            {showCategoryLabel ? (
              <DropdownSectionLabel>{category.label}</DropdownSectionLabel>
            ) : null}
            <DropdownMenuGroup>
              {category.sections.map((section) => {
                const href = getWorkspaceSettingsSectionHref(section, workspaceId);
                const isActive = isSettingsSectionActive(activePathname, href, section.id);

                return (
                  <DropdownMenuItem
                    key={section.id}
                    onClick={() => {
                      onNavigate(href);
                      onClose();
                    }}
                    className={cn(isActive && "bg-muted")}
                  >
                    {isValidElement(section.icon)
                      ? cloneElement(section.icon, {
                          className: cn(
                            "h-4 w-4 shrink-0",
                            isActive ? "text-foreground" : "text-muted-foreground"
                          ),
                        })
                      : null}
                    <span className="flex-1">{section.title}</span>
                  </DropdownMenuItem>
                );
              })}
            </DropdownMenuGroup>
          </div>
        );
      })}
    </>
  );
};
